import { Avatar, Box, Divider, MenuItem, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";

import MenuPopover from "@/components/MenuPopover";
import { IconButtonAnimate } from "@/components/animate";
import useAuth from "@/providers/hooks/useAuthProvider";
import createAvatar from "@/utils/createAvatar";

type MenuOption = {
    label: string;
    linkTo: string;
};

export default function AccountPopover() {
    const { handleLogout, userData } = useAuth();
    const { t } = useTranslation();
    const [open, setOpen] = useState<HTMLElement | null>(null);
    const fullName = userData?.name || "";

    const MENU_OPTIONS: MenuOption[] = [
        {
            label: t("dashboard"),
            linkTo: "/dashboard",
        },
    ];

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setOpen(event.currentTarget);
    };

    const handleClose = () => {
        setOpen(null);
    };

    return (
        <>
            <IconButtonAnimate
                onClick={handleOpen}
                sx={{
                    p: 0,
                    ...(open && {
                        "&:before": {
                            zIndex: 1,
                            content: "''",
                            width: "100%",
                            height: "100%",
                            borderRadius: "50%",
                            position: "absolute",
                            bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
                        },
                    }),
                }}
            >
                <Avatar
                    // src={userData?.avatarPath ? `${userData.avatarPath}/${userData.avatar}` : undefined}
                    alt={fullName}
                    // color={userData?.avatar ? "default" : createAvatar(fullName).color}
                >
                    {createAvatar(fullName).name}
                </Avatar>
            </IconButtonAnimate>

            <MenuPopover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleClose}
                disabledArrow={false}
                sx={{
                    p: 0,
                    mt: 1.5,
                    ml: 0.75,
                    "& .MuiMenuItem-root": {
                        typography: "body2",
                        borderRadius: 0.75,
                    },
                }}
            >
                <Box sx={{ my: 1.5, px: 2.5 }}>
                    <Typography variant="subtitle2" noWrap>
                        {fullName}
                    </Typography>
                </Box>

                <Divider sx={{ borderStyle: "dashed" }} />

                <Stack sx={{ p: 1 }}>
                    {MENU_OPTIONS.map((option) => (
                        <MenuItem key={option.label} component={RouterLink} to={option.linkTo} onClick={handleClose}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Stack>

                <Divider sx={{ borderStyle: "dashed" }} />

                <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
                    {t("logout")}
                </MenuItem>
            </MenuPopover>
        </>
    );
}
